import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import CommunityApp from "@/community/CommunityApp";

function App() {
  return (
    <div className="App grain">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/community" element={<CommunityApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
